import { z } from 'zod';

/////////////////////////////////////////
// CODE ENFORCEMENT VEHICLE SCHEMA
/////////////////////////////////////////

export const CodeEnforcementVehicleSchema = z.object({
  vehicleId: z.number().int(),
  cityId: z.number().int(),
  caseId: z.number().int(),
  vehicleStatus: z.string(),
  vehicleMake: z.string(),
  vehicleModel: z.string(),
  vehicleYear: z.string(),
  vehicleColor: z.string(),
  vehicleLicense: z.string(),
  vehicleState: z.string(),
  vehicleExpire: z.string(),
  vehicleVIN: z.string(),
  note: z.string(),
  dateVehicleClosed: z.coerce.date(),
  rowTimestamp: z.coerce.date(),
})

export type CodeEnforcementVehicle = z.infer<typeof CodeEnforcementVehicleSchema>

export default CodeEnforcementVehicleSchema;
